import Vue from 'vue';
import axios from 'axios';
import '../../../../filters';
import moment from 'moment';

export default {
  name: 'CustomTable',
  components: {
    
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      message: '',
    }
  },
  created() {
    this.appId = this.dataObj;
  },
  methods: {
    pageChange(pInfo) {
      //var parameters = { Value: this.appId, PageSize: pInfo.pageSize, Page: pInfo.pageNumber, FilterText: this.search };
      //this.getReadings();
    },
    closeDialog() {
      //this.editingMessage = '';
      //this.getReadings();
      //this.showReading = false;
    },
  },
  
}

